import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import Locale from 'localization/Localization';
import { LoginForm } from 'components/login/LoginForm';
import { PublicLayout } from 'components/public/PublicLayout';
import { Spinner } from 'components/common/Spinner';
import { AppServices } from 'services/AppServices';

interface LoginPageState {
	checkIsFinished: boolean;
	hasSession: boolean;
}

export class LoginPage extends React.Component<RouteComponentProps<{}>, LoginPageState>
{
	private static defaultRedirectPath = '/home';

	constructor(props: RouteComponentProps<{}>) {
		super(props);

		this.state = { checkIsFinished: false, hasSession: false };
	}

	public componentDidMount() {
		document.title = Locale.getPageTitle('page_login');

		// Check session
		AppServices.loginService.verifySession()
			.then(result => {
				this.setState({checkIsFinished: true, hasSession: result});
			})
	}

	public render() {
		if (this.state.checkIsFinished) {
			if (this.state.hasSession) {
				return <Redirect to={LoginPage.defaultRedirectPath} />;
			}
			else {
				let redirectPath = LoginPage.defaultRedirectPath;

				if (this.props.location.state !== null &&
					typeof this.props.location.state === 'object' &&
					typeof (this.props.location.state as any).referrer === 'string')
					redirectPath = (this.props.location.state as any).referrer;

				return <PublicLayout>
					<LoginForm redirectPath={redirectPath} />
				</PublicLayout>;
			}
		}
		else // Not sure yet
			return <PublicLayout><Spinner /></PublicLayout>;
	}
}